export enum ExternalCampaignMetricsStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Error = 'error'
}
